import axios from 'axios'
import router from './router'
import { Message } from 'element-ui'

// 添加request拦截器 
axios.interceptors.request.use(
    config => {
        let token = window.sessionStorage.getItem("session");
        if (!token) {
            token = window.localStorage.getItem("session");
        }
        config.params = { "session": token }
        console.log("session: ", token)
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// 添加respone拦截器
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        let response = error.response
        let status = response.status
        if (status === 400) {
            Message.error("请求数据不正确！")
            return Promise.reject(error.response)
        }
        if (status === 500) {
            Message.error("系统错误，请联系管理员！")
            return Promise.reject(error.response)
        }
        if (status === 401) {
            window.sessionStorage.removeItem("token");
            window.localStorage.removeItem("token");
            router.push({ path: "/login" })
        }
        if (status === 403 && location.pathname != "/") {
            // sessionStorage.removeItem("session")
            router.push({ path: "/login" })
        }
        return Promise.reject(error.response)
    },
)

axios.defaults.baseURL = "http://api.dc.114dev.com";
axios.defaults.withCredentials = true;

export default axios;